module.exports = [
  {
    path: '/role',
    component: true,
    redirect: '/role/list',
    name: '角色管理',
    children: [
      {
        path: 'list',
        name: '列表',
        component: () => import('@/views/role/list'),
      },
      {
        path: 'form',
        name: '表单',
        component: () => import('@/views/role/form'),
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/role.js